import axios from 'axios';


const axiosInstance = axios.create({
    //baseURL: 'http://localhost:5050/api',//process.env.REACT_APP_API_BASE_URL,
    //baseURL: '/api',//process.env.REACT_APP_API_BASE_URL,
    baseURL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5050/api',
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: process.env.NODE_ENV === 'production'? false : true,
});

axiosInstance.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('token');
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        return config;
    }, 
    //error => { return Promise.reject(error); }
);


export default axiosInstance;
